import GradingPopupContent from './GradingPopupLazy'
import { GradingPopupProps } from './GradingPopup'
export type { GradingPopupProps }
export default GradingPopupContent
